var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Page 1 Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97275 3.77567H7.55608V9.44234L12.0422 12.134L12.7505 10.9723L8.97275 8.734V3.77567ZM8.5 0C3.80517 0 0 3.80517 0 8.5C0 13.1948 3.80517 17 8.5 17C13.1948 17 17 13.1948 17 8.5C17 3.80517 13.1948 0 8.5 0ZM8.49895 15.1101C4.84772 15.1101 1.88783 12.1502 1.88783 8.49895C1.88783 4.84772 4.84772 1.88783 8.49895 1.88783C12.1502 1.88783 15.1101 4.84772 15.1101 8.49895C15.1101 12.1502 12.1502 15.1101 8.49895 15.1101Z",
    fill: "#303A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBold);
export default __webpack_public_path__ + "static/media/clock_bold.767b6385407126dbce034408ea2daace.svg";
export { ForwardRef as ReactComponent };